import React from 'react';
import { Tabs, Typography } from 'antd'

import styles from './subscription.module.css'
import useWindowDimensions from '../../hooks/useWindowDimensions';
import SubscriptionPlans from './SubscriptionPlans';
import SubscriptionHistory from './SubscriptionHistory';
import { useTranslation } from 'react-i18next';


function Subscription() {
    const {Text } = Typography;
    const {t} = useTranslation();
    
  const {width,height} = useWindowDimensions()
    const items = [
        {
          key: "1",
          label: `${t("Subscription Plans")}`,
          children: <SubscriptionPlans />,
        },
        {
          key: "2",
          label: `${t("Subscription History")}`,
          children: <SubscriptionHistory />,
        },
        // {
        //   key: "3",
        //   label: `Inventory`,
        //   children: <Inventory />,
        // },
        // {
        //   key: "4",
        //   label: 'Message',
        //   children: <Message />,
        // },
      ];
  return (
    <div className={styles.mainCont}>
        <Text className={styles.subText}>{t("Subscription Plans")}</Text>
        <Tabs
          className="tab_content_styling"
          size="large"
          defaultActiveKey="1"
          items={items}
          tabBarGutter={width > 570 ? 50 : 5}
          tabBarStyle={width > 570  ? {
            color: "white",
            fontWeight: "bold",
            width: "100%",
          } : {
            color: "white",
            fontSize:'8px'
          } }
          
        />
    </div>
  )
}

export default Subscription